/** Formatadores compartilhados (pt-BR). */

export function formatBRL(n: number): string {
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Compacto, no estilo do design: R$ 84,2k · R$ 1,1M. */
export function formatBRLCompact(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `R$ ${(n / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}M`;
  if (Math.abs(n) >= 1_000) return `R$ ${(n / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}k`;
  return formatBRL(n);
}

export function formatInt(n: number): string {
  return n.toLocaleString('pt-BR');
}

export function formatPct(n: number, digits = 1): string {
  return `${n.toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;
}

export const PLANO_LABEL: Record<string, string> = {
  starter: 'Starter',
  growth: 'Growth',
  scale: 'Scale',
};

export const ASSINATURA_LABEL: Record<string, string> = {
  ativa: 'ativa',
  trial: 'trial',
  inadimplente: 'em atraso',
  churned: 'cancelada',
};

export const SAUDE_LABEL: Record<string, string> = {
  saudavel: 'Saudável',
  atencao: 'Atenção',
  em_falha: 'Em falha',
};

export const SAUDE_COLOR: Record<string, string> = {
  saudavel: 'var(--accent)',
  atencao: 'var(--amber)',
  em_falha: 'var(--risk)',
};

export const AGENTE_STATUS_LABEL: Record<string, string> = {
  operando: 'Operando',
  lento: 'Lento',
  falha: 'Em falha',
};

export const AGENTE_STATUS_COLOR: Record<string, string> = {
  operando: 'var(--accent)',
  lento: 'var(--amber)',
  falha: 'var(--risk)',
};

export function mesLabel(yyyymm: string): string {
  const [y, m] = yyyymm.split('-');
  const nomes = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  return `${nomes[Number(m) - 1] ?? m}/${y!.slice(2)}`;
}

// ── Leads / CRM ──────────────────────────────────────────────────────────
export const LEAD_ESTAGIOS = ['novo', 'contato', 'demo', 'proposta', 'ganho', 'perdido'] as const;
export const LEAD_ESTAGIO_LABEL: Record<string, string> = {
  novo: 'Novo',
  contato: 'Contato feito',
  demo: 'Demo agendada',
  proposta: 'Proposta enviada',
  ganho: 'Fechado (ganho)',
  perdido: 'Perdido',
};
export const ORIGEM_LABEL: Record<string, string> = {
  site: 'Site',
  indicacao: 'Indicação',
  prospeccao: 'Prospecção',
  evento: 'Evento',
};

// ── Suporte ──────────────────────────────────────────────────────────────
export const TICKET_STATUS_LABEL: Record<string, string> = {
  aberto: 'Aberto',
  aguardando: 'Aguardando',
  resolvido: 'Resolvido',
};
export const TICKET_STATUS_COLOR: Record<string, string> = {
  aberto: 'var(--accent)',
  aguardando: 'var(--amber)',
  resolvido: 'var(--ink-3)',
};
export const PRIORIDADE_LABEL: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
};
export const PRIORIDADE_COLOR: Record<string, string> = {
  baixa: 'var(--ink-3)',
  media: 'var(--ink-2)',
  alta: 'var(--amber)',
  urgente: 'var(--risk)',
};
export const CANAL_LABEL: Record<string, string> = {
  email: 'E-mail',
  whatsapp: 'WhatsApp',
  chat: 'Chat',
};
export const AUTOR_LABEL: Record<string, string> = {
  cliente: 'Cliente',
  suporte: 'Suporte',
  ia: 'Agente IA',
};

// ── Financeiro / cobrança ────────────────────────────────────────────────
export const COBRANCA_STATUS_LABEL: Record<string, string> = {
  pago: 'Pago',
  pendente: 'Pendente',
  atrasado: 'Atrasado',
};
export const COBRANCA_STATUS_COLOR: Record<string, string> = {
  pago: 'var(--accent)',
  pendente: 'var(--amber)',
  atrasado: 'var(--risk)',
};
